import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";

// Landing page for the Okta SSO redirect. The backend sends the browser here
// with the backend JWT in the URL fragment (#token=...). We grab it, strip it
// from the address bar, establish the session, and bounce to the dashboard.
const SsoCallback = () => {
  const navigate = useNavigate();
  const { loginWithToken } = useAuth();
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;

    const rawHash = window.location.hash || "";
    const params = new URLSearchParams(rawHash.startsWith("#") ? rawHash.slice(1) : rawHash);
    const token = params.get("token");

    // Drop the token from the URL bar / history before doing anything else.
    window.history.replaceState(null, "", window.location.pathname);

    if (!token) {
      navigate("/login?sso_error=token", { replace: true });
      return;
    }

    loginWithToken(token).then((res) => {
      navigate(res && res.success ? "/dashboard" : "/login?sso_error=token", { replace: true });
    });
  }, [loginWithToken, navigate]);

  return (
    <div className="min-h-screen bg-cyber-50 cyber-grid-bg flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-shinobi-purple mx-auto"></div>
        <p className="mt-4 text-slate-500">Signing you in…</p>
      </div>
    </div>
  );
};

export default SsoCallback;
